// extracted by mini-css-extract-plugin
module.exports = {"upload-print-file":"modalUpdateProduct_upload-print-file__o5HWu"};